export const getProducts = () => async (dispatch) => {
  try {
    const res = await fetch(`https://amazonbackendapp.onrender.com/getproducts`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const data = await res.json();
    // console.log("data from action ", data);
    dispatch({ type: "SUCCESS_GET_PRODUCTS", payload: data });
  } catch (error) {
    dispatch({ type: "FAIL_GET_PRODUCTS", payload: error.response });
  }
};
